import React from 'react';
import { Header, Footer, About, TPV, Hero } from '../components';

const Home: React.FC = () => {
    return (
        <div>
            
            <Hero/>
            <About/>
            <TPV/>
            
        </div>
    );
};

export default Home; 